module.exports = __webpack_public_path__ + "img/go-global.5427d7ca.png";